import {
	SET_ACTIVITIES,
	SET_ACTIVITY,
	CLEAR_ACTIVITIES,
	CLEAR_ACTIVITY,
	ADD_ACTIVITY,
	UPDATE_ACTIVITY,
	REMOVE_ACTIVITY,
} from './actionTypes';

export const activity = (state = {}, action) => {
	switch (action.type) {
		case SET_ACTIVITY:
			return action.payload;
		case UPDATE_ACTIVITY:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_ACTIVITY:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_ACTIVITIES:
			return action.payload;
		case ADD_ACTIVITY:
			return [...state, action.payload];
		case UPDATE_ACTIVITY:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_ACTIVITY:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_ACTIVITIES:
			return [];
		default:
			return state;
	}
};
